import React from 'react';
import { createStyles, Drawer, Fade, makeStyles, Slide } from '@material-ui/core';
import { AboutSidebar, AppModelsSidebar, PricingSidebar } from './SidebarComponents';
import { AuthSidebar } from './AuthSidebar';
import clsx from 'clsx';
import { SmallScreenSide } from './SmallScreenSide';
import { CloseButton, RightCloseButton } from './styledComponent';
import { useBaseLayoutCloseSide, useBaseLayoutState } from '../BaseLayoutProvider';
import { useScrollStyle } from 'src/components-pages/shared/scrollStyled';

const useStyle = makeStyles((theme) =>
    createStyles({
        drawerInner: {
            width: 500,
            height: '100%',
            padding: theme.spacing(1),
            paddingTop: (theme.mixins.toolbar.minHeight as number) + theme.spacing(2),
            backgroundColor: theme.palette.grey['400'],
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto',
            position: 'relative',
            [theme.breakpoints.down('sm')]: {
                width: '100vw'
            }
        },

        btnText: { color: '#FFF' },
        buttons: {
            marginLeft: theme.spacing(4)
        },

        sidebarWrapper: {
            position: 'absolute',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start'
        },
        centerSidebar: {
            alignItems: 'center',
            justifyContent: 'center',
            left: 0,
            right: 0
        },
        iconXSQuery: {
            [theme.breakpoints.down('xs')]: {
                display: 'none'
            }
        }
    })
);
interface Props {
    // layoutState: LayoutState;
    // closeSidebar: () => void;
    // layoutdispatch: React.Dispatch<any>;
}

function MultipleAnimation({
    children,
    isIn,
    wrapperClassName,
    direction = 'right'
}: {
    children: React.ReactNode;
    wrapperClassName: string;
    isIn: boolean;
    direction?: 'left' | 'right';
}) {
    return (
        <Fade in={isIn}>
            <div>
                <Slide direction={direction} in={isIn} mountOnEnter unmountOnExit>
                    <div className={wrapperClassName}>{children}</div>
                </Slide>
            </div>
        </Fade>
    );
}

const AppSidebar = ({}: Props) => {
    const classes = useStyle();
    const scrollStyled = useScrollStyle();
    const layoutState = useBaseLayoutState();
    const handleClose = useBaseLayoutCloseSide();

    return (
        <>
            <Drawer anchor="left" open={layoutState.leftOpen} onClose={handleClose}>
                <div className={clsx(classes.drawerInner, scrollStyled.scroll)}>
                    <CloseButton handleClose={handleClose} className={classes.iconXSQuery} />

                    <MultipleAnimation
                        wrapperClassName={classes.sidebarWrapper}
                        isIn={layoutState.sidebarType === 'SMALL_NAVBAR'}>
                        <SmallScreenSide />
                    </MultipleAnimation>

                    <MultipleAnimation
                        wrapperClassName={classes.sidebarWrapper}
                        isIn={layoutState.sidebarType === 'ABOUT'}>
                        <AboutSidebar />
                    </MultipleAnimation>
                    <MultipleAnimation
                        wrapperClassName={classes.sidebarWrapper}
                        isIn={layoutState.sidebarType === 'APPMODELS'}>
                        <AppModelsSidebar />
                    </MultipleAnimation>
                    <MultipleAnimation
                        wrapperClassName={classes.sidebarWrapper}
                        isIn={layoutState.sidebarType === 'PRICING'}>
                        <PricingSidebar />
                    </MultipleAnimation>
                </div>
            </Drawer>
            <Drawer anchor="right" open={layoutState.rightOpen} onClose={handleClose}>
                <div className={classes.drawerInner}>
                    <RightCloseButton handleClose={handleClose} className={classes.iconXSQuery} />

                    <MultipleAnimation
                        direction="left"
                        wrapperClassName={clsx(classes.sidebarWrapper, classes.centerSidebar)}
                        isIn={layoutState.sidebarType === 'LOGIN'}>
                        <AuthSidebar mode="LOGIN" />
                    </MultipleAnimation>
                    <MultipleAnimation
                        direction="left"
                        wrapperClassName={clsx(classes.sidebarWrapper, classes.centerSidebar)}
                        isIn={layoutState.sidebarType === 'REGISTER'}>
                        <AuthSidebar mode="REGISTER" />
                    </MultipleAnimation>
                </div>
            </Drawer>
        </>
    );
};

export default AppSidebar;
